module.exports = __webpack_public_path__ + "static/media/close.50013ec0.png";